// Generated file : do not modify
export enum CiviliteGenres
{
  NONE = 0,
  MASCULIN,
  FEMININ
};

import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Civilités des contacts
export default class Civilite  {
  // Identifiant unique
  public id: number;
  // Civilité
  public label: string;
  // Genre
  public genre: CiviliteGenres;
  // Civilité affichée
  public displayed: boolean;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;

  constructor() {
    this.id = 0;
    this.label = '';
    this.genre = CiviliteGenres.NONE;
    this.displayed = false;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
  }

  public static fromJson (obj: Civilite): Civilite {
    const newCivilite: Civilite = new Civilite();
    newCivilite.id = obj.id;
    newCivilite.label = obj.label;
    newCivilite.genre = obj.genre;
    newCivilite.displayed = obj.displayed;
    newCivilite.createId = obj.createId;
    newCivilite.failed = obj.failed;
    newCivilite.canUpdate = obj.canUpdate;
    newCivilite.canDelete = obj.canDelete;
    newCivilite.display = obj.display;
    newCivilite.notifDefType = obj.notifDefType;
    return newCivilite;
  }

  public toJsonCivilite (): string {
    const json = {
      label: this.label,
      genre: this.genre,
      displayed: this.displayed,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromCivilite (obj: Civilite): void {
    this.id = obj.id;
    this.label = obj.label;
    this.genre = obj.genre;
    this.displayed = obj.displayed;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
  }

  public compareCivilite (value: Civilite): boolean {
    return (this.toJsonCivilite() == value.toJsonCivilite());
  }

  public cloneCivilite (): Civilite {
    return Civilite.fromJson(this);
  }

  public createForStoreCivilite (): Promise<Civilite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/civilites/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromCivilite(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public updateForStoreCivilite (): Promise<Civilite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.put('api/civilites/', this, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              this.fromCivilite(res.data);
              resolve(this);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public deleteForStoreCivilite (): Promise<void> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.delete('api/civilites/' + this.id, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve();
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/civilites/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Civilites/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Civilite.fromJson(listData.reccords[0] as Civilite);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Civilite> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Civilites/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Civilite.fromJson(listData.reccords[0] as Civilite);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  // eslint-disable-next-line
  public static getDate(civilites: Civilite[]) {
  }
}
